import React from 'react';

const PostalCodeLookup = () => (
  <div>
    <div className="subheader">
      <h1 className="subheader-title">
        <i className="subheader-icon fal fa-location-circle mr-2" />
        Postal Code Lookup
        <small>
          Powered by Canada Post
        </small>
      </h1>
    </div>
  </div>
);

export default PostalCodeLookup;
